import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

export const modalLarge: NgbModalOptions = {
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
}

export const modalSmall: NgbModalOptions = {
    size: 'sm',
    backdrop: 'static',
    keyboard: false,
    centered: true
}

export const modalMyClass: NgbModalOptions = {
    windowClass: "my-class",
    backdrop: 'static',
    keyboard: false,
    centered: true
}

export const modalIssueClass: NgbModalOptions = {
    windowClass: "issueClass",
    backdrop: 'static',
    keyboard: false,
    centered: true
}

export const modalCreateType: NgbModalOptions = {
    size: 'lg',
    windowClass: "modal-create-type",
    backdrop: 'static',
    keyboard: false,
    centered: true
}

export const modalDatasource: NgbModalOptions = {
    windowClass: 'modal-datasource-editor',
    backdrop: 'static',
    keyboard: false,
    centered: true
}



// WEBPACK FOOTER //
// ./src/app/shared/modules/dialogOptions.ts